import React from 'react'
import { NavigateContext } from '../../contexts/NavigateContext'

export function Pill({ label, value, unit, color = 'var(--text)', tooltip, sub, guideKey }) {
  return (
    <div title={tooltip} style={{ background: 'var(--chip-bg)', borderRadius: 12, padding: '12px 14px', flex: 1, minWidth: 0, position: 'relative' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <p style={{ fontSize: 10, color: 'var(--text-faint)', marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.6, fontWeight: 600 }}>{label}</p>
        {guideKey && (
          <NavigateContext.Consumer>
            {navigate => navigate && (
              <button onClick={() => navigate('/guia?s=' + guideKey)} title="Ver en guía" style={{
                background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-fainter)',
                fontSize: 9, padding: '0 2px', fontFamily: 'inherit', lineHeight: 1,
              }}>?</button>
            )}
          </NavigateContext.Consumer>
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 3 }}>
        <span style={{ fontSize: 24, fontWeight: 700, color, fontVariantNumeric: 'tabular-nums' }}>{value ?? '–'}</span>
        {unit && <span style={{ fontSize: 10, color: 'var(--text-faint)' }}>{unit}</span>}
      </div>
      {sub && <p style={{ fontSize: 10, color: 'var(--text-fainter)', marginTop: 3, lineHeight: 1.3 }}>{sub}</p>}
    </div>
  )
}
